module.exports = __webpack_public_path__ + "static/media/Matt_Austin.3674b259.jpg";